import {
  ScheduledDaysOfTheWeek,
  ScheduledTransactionRecurringScheduleType,
} from '@/types/transactions';

export const SCHEDULED_TRANSACTION_FREQUENCY_OPTIONS: {
  value: ScheduledTransactionRecurringScheduleType;
  label: string;
}[] = [
  {
    value: 'monthly',
    label: 'Monthly',
  },
  {
    value: 'weekly',
    label: 'Weekly',
  },
  {
    value: 'every two weeks',
    label: 'Every Two Weeks',
  },
  {
    value: 'every four weeks',
    label: 'Every Four Weeks',
  },
  {
    value: 'every other month',
    label: 'Every Other Month',
  },
];

export const SCHEDULED_TRANSACTION_SEND_ON_MONTHLY_OPTIONS: {
  value: string;
  label: string;
}[] = [
  { value: '1', label: '1st of the Month' },
  { value: '2', label: '2nd of the Month' },
  { value: '3', label: '3rd of the Month' },
  { value: '4', label: '4th of the Month' },
  { value: '5', label: '5th of the Month' },
  { value: '6', label: '6th of the Month' },
  { value: '7', label: '7th of the Month' },
  { value: '8', label: '8th of the Month' },
  { value: '9', label: '9th of the Month' },
  { value: '10', label: '10th of the Month' },
  { value: '11', label: '11th of the Month' },
  { value: '12', label: '12th of the Month' },
  { value: '13', label: '13th of the Month' },
  { value: '14', label: '14th of the Month' },
  { value: '15', label: '15th of the Month' },
  { value: '16', label: '16th of the Month' },
  { value: '17', label: '17th of the Month' },
  { value: '18', label: '18th of the Month' },
  { value: '19', label: '19th of the Month' },
  { value: '20', label: '20th of the Month' },
  { value: '21', label: '21st of the Month' },
  { value: '22', label: '22nd of the Month' },
  { value: '23', label: '23rd of the Month' },
  { value: '24', label: '24th of the Month' },
  { value: '25', label: '25th of the Month' },
  { value: '26', label: '26th of the Month' },
  { value: '27', label: '27th of the Month' },
  { value: '28', label: '28th of the Month' },
  { value: '29', label: '29th of the Month' },
  { value: '30', label: '30th of the Month' },
  { value: '31', label: 'Last' },
];

export const SCHEDULED_TRANSACTION_SEND_ON_WEEKLY_OPTIONS: {
  value: ScheduledDaysOfTheWeek;
  label: string;
}[] = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
];
